import React, { Component } from 'react';
import withStyles from '@material-ui/styles/withStyles';
import { Link, withRouter } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import Toolbar from '@material-ui/core/Toolbar';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import { ClickAwayListener, Grow, Link as MaterialLink, MenuItem, MenuList, Paper, Popper, Typography } from '@material-ui/core';
import Menu from './Menu';
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import Amplify, { Auth } from 'aws-amplify';
import awsconfig from '../aws-exports';
import 'react-slidedown/lib/slidedown.css';
import HomeIcon from '@material-ui/icons/Home';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import moment from 'moment-timezone';
import { CountryList } from '../common/CountryList';
import './Topbar.css';
import jwt from 'jsonwebtoken';
import axiosInstance, { EVENT_CODE, EVENT_IMG, getEventId, tokenRefresh, WEB_API } from '../constatns';
import swal from '@sweetalert/with-react';
Amplify.configure(awsconfig);

const styles = (theme) => ({
  header: {
    position: 'relative',
    width: '100%',
    backgroundSize: '100%',
    zIndex: 888,
  },
  appBar: {
    position: 'relative',
    boxShadow: 'none',
  },
  toolBar: {
    width: '100%',
    minHeight: 84,
    height: '100%',
    '& .MuiTabs-root': {
      height: '100%',
    },
    '& .MuiTabs-scroller': {
      display: 'flex',
    },
    [theme.breakpoints.down('sm')]: {
      paddingRight: '0px',
    },
  },
  inline: {
    display: 'inline',
    [theme.breakpoints.down('sm')]: {
      padding: 0,
      paddingTop: '0.5em',
    },
  },
  logo: {
    padding: 10,
    // width: 'auto',
    width: '270px',
    [theme.breakpoints.down('sm')]: {
      padding: 0,
      // width: '100px',
    },
  },
  topbarMenusDiv: {
    fontSize: '1em',
    fontWeight: 'bold',
    cursor: 'pointer',
    // position: 'absolute',
    // right: '150px',
    // top: 0,
    // transform: 'translateY(50%)',
    [theme.breakpoints.down('sm')]: {
      // display: 'none',
    },
  },
  iconContainer: {
    display: 'none',
    [theme.breakpoints.down('sm')]: {
      display: 'block',
    },
  },
  iconButton: {
    float: 'right',
  },
  tabContainer: {
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  tabs: {
    background: '#fff',
  },
  tabItem: {
    textTransform: 'none',
    paddingTop: 20,
    paddingBottom: 20,
    minWidth: 200,
    minHeight: 70,
    fontSize: '1.1rem',
    color: theme.palette.primary.main,
    opacity: 1,
    fontWeight: 'bold',
    [theme.breakpoints.down('md')]: {
      minWidth: 140,
    },
    '&:hover': {
      backgroundColor: theme.palette.primary.main,
      opacity: 1,
      color: 'white',
    },
    '&$selected': {
      backgroundColor: '#004C9B',
      color: 'white',
    },
  },
  menus: {
    listStyle: 'none',
    '& li': {
      display: 'inline-block',
      marginLeft: '10px',
    },
  },
  drawer: {
    backgroundColor: 'rgba(28,30,59,.90)',
    color: '#adbecc',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  drawerMenus: {
    '& ul': {
      listStyle: 'none',
      padding: 0,
      minWidth: '200px',
      '& li': {
        cursor: 'pointer',
        // lineHeight: '2.8em',
        lineHeight: 2.5,
        fontSize: '1em',
        textAlign: 'center',
        // color: '#555555',
        '&:hover': {
          // color: '#ffffff',
          color: '#aacb3c !important',
        },
      },
    },
  },
  breadcrumbs: {
    color: '#aeaeae',
    padding: '10px',
  },
  crumbs: {
    '&:first-child': {
      cursor: 'pointer',
      paddingRight: '10px',
    },
    '&:nth-child(2)': {
      paddingLeft: '10px',
    },
    '&:last-child': {
      cursor: 'pointer',
      paddingLeft: '10px',
      paddingRight: '10px',
    },
    '&:not(:first-child)': {
      minWidth: 200,
    },
    borderRight: '1px solid #ffffff',
    '& .MuiPaper-root': {
      width: 200,
      maxWidth: 200,
      borderRadius: 0,
      marginTop: 14,
      marginLeft: 5,
      '& li': {
        fontSize: '0.9em',
      },
    },
  },

  timeZoneDiv: {
    position: 'fixed',
    right: 0,
    bottom: '15px',
    zIndex: 999,
    borderRadius: '5px',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  gmtDiv: {
    backgroundColor: '#164273',
    marginBottom: '0.8em',
  },
  yourTimezoneDiv: {
    backgroundColor: '#aacb3c',
    marginBottom: '0.8em',
  },

  kstDiv: {
    backgroundColor: '#7d889a',
    marginBottom: '0.8em',
  },

  timezoneBox: {
    width: '240px',
    color: '#fff',
    textAlign: 'center',
    padding: theme.spacing(2.5),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-between',
    '& div:first-child': {
      width: '100%',
      textAlign: 'left',
    },
  },
  timezoneName: {
    fontSize: '1.2em',
    fontWeight: 500,
  },
  timezoneDate: {
    fontSize: '1.1em',
    fontWeight: 600,
  },
  timezoneTime: {
    width: '100%',
    display: 'flex',
    alignItems: 'baseline',
    justifyContent: 'space-between',
    '& p:last-child': {
      fontSize: '2em',
      fontWeight: 300,
      display: 'flex',
    },
    '& span': {
      fontSize: '0.6em',
      fontWeight: 100,
      marginLeft: theme.spacing(0.5),
      paddingTop: '0.3em',
    },
  },
  goWebinar: {
    position: 'absolute',
    width: '25%',
    height: '53%',
    top: '25%',
    right: '9%',
    border: '1px solid #eeeeee',
    boxShadow: '3px 3px 5px #eeeeee',
    cursor: 'pointer',
  },
});

class Topbar extends Component {
  timeOut = null;
  constructor(props) {
    super(props);
    this.state = {
      value: 0,
      menuDrawer: false,
      username: '',
      mainSocket: null,
      show: false,
      submenuOpen: false,
      timezone: '',
      accessCountry: '',
      now: moment(),
      tick: null,
      role: sessionStorage.getItem('_in_role'),
    };
    this.myRef = React.createRef();
    this.logout = this.logout.bind(this);
    this.showMenus = this.showMenus.bind(this);
    this.hideMenus = this.hideMenus.bind(this);
    this.socketManager = this.socketManager.bind(this);

    if (!sessionStorage.getItem('_in_user_')) {
      // this.props.history.push('signin');
    }
  }

  handleChange = (event, value) => {
    this.setState({ value });
  };

  mobileMenuOpen = (event) => {
    this.setState({ menuDrawer: true });
  };

  mobileMenuClose = (event) => {
    this.setState({ menuDrawer: false });
  };

  handleToggle = () => {
    this.setState({ submenuOpen: !this.state.submenuOpen });
  };

  handleClose = (event) => {
    if (this.myRef.current && this.myRef.current.contains(event.target)) {
      return;
    }
    this.setState({ submenuOpen: false });
  };

  logout() {
    localStorage.clear();
    sessionStorage.clear();
    Auth.signOut().then(() => {
      this.props.history.push('/');
    });
  }

  componentDidMount() {
    const EVT = sessionStorage.getItem('EVENT');
    if (!EVT) {
      axiosInstance
        .get(`${WEB_API}/event/info?eventId=${getEventId()}&code=${encodeURIComponent(EVENT_CODE)}`, {
          headers: { Pragma: 'no-cache' },
        })
        .then((response) => {
          if (response.data.Item) {
            sessionStorage.setItem('EVENT_ID', getEventId());
            sessionStorage.setItem('EVENT', JSON.stringify(response.data.Item));
          }
        });
    }
    // check token expire
    const decoded = jwt.decode(sessionStorage.getItem('_in_jwt'));
    if (decoded) {
      console.log(
        'tokenExp',
        moment(decoded.exp * 1000)
          .tz('Asia/Seoul')
          .format('YYYY-MM-DD HH:mm:ss'),
      );
      const exp = moment(decoded.exp * 1000);
      const now = moment();
      const diff = exp.diff(now, 'minutes');
      console.log(`토근 만료까지 ${diff}분 남았습니다.`);
      if (diff < 10) tokenRefresh().then((r) => {});
    }

    this.getUserIP();
    this.socketManager();
  }

  componentWillUnmount() {
    if (this.state.mainSocket) {
      this.state.mainSocket.close();
      delete this.state.mainSocket;
      this.setState({ mainSocket: null });
    }
    clearTimeout(this.timeOut);
  }

  socketManager() {}

  current = () => {
    return this.props.MIdx < Menu.length - 1 ? this.props.MIdx : 0;
  };

  showMenus() {
    this.setState({ show: true });
  }
  hideMenus() {
    this.timeOut = setTimeout(() => {
      this.setState({ show: false });
    }, 1000);
  }

  getUserIP() {
    const { now, tick } = this.state;

    if (tick !== null) {
      clearInterval(tick);
      this.setState({ tick: null });
    }

    // console.log(now);
    let currentTime = now.tz(moment.tz.guess());
    // console.log('YourTimezone ', moment.tz.guess()); // America/Toronto
    // console.log('YourTimezoneName ', currentTime.format('z')); // EDT
    // console.log('Now', now.format('YYYY.MM.DD hh:mm A'));
    // console.log('KST', now.tz('Asia/Seoul').format('YYYY.MM.DD hh:mm A'));
    // console.log('America/Toronto', now.tz('America/Toronto').format('YYYY.MM.DD hh:mm A'));
    this.setState({ accessCountry: moment.tz.guess(), timezone: moment.tz.guess() });

    let buff = setInterval(() => {
      this.setState({ now: moment() });
    }, 6000);
    this.setState({ tick: buff });

    // axios
    //   .get('https://ipinfo.io/json?token=c76190236a0eea', { headers: { Pragma: 'no-cache' } })
    //   .then((res) => {
    //     if (res.status === 200) {
    //       if (res.data && res.data.timezone) {
    //         this.getCountryName(res.data.country);
    //         this.setState({ timezone: res.data.timezone });
    //       }
    //     }
    //   })
    //   .catch((err) => {
    //     console.error(err);
    //   });
  }

  getCountryName(countryCode) {
    CountryList.forEach((item) => {
      if (item.code === countryCode) {
        this.setState({ accessCountry: item.name });
      }
    });
  }

  render() {
    const { classes, history } = this.props;
    const { now } = this.state;

    return (
      <>
        <div
          className={classes.header}
          style={this.props.location.pathname === '/main' || this.props.location.pathname === '/' ? {} : { marginBottom: '30px' }}
        >
          <AppBar position="static" color="default" className={classes.appBar}>
            <Toolbar className={classes.toolBar}>
              <Grid container spacing={4} justifyContent="center" alignItems={'center'}>
                <Grid item xs={11} container justifyContent="flex-start">
                  <Grid item xs={5}>
                    <Link to="/main" className={classes.link}>
                      <img src="/images/PRS2021/prs2021_logo@2x.png" alt="" className={classes.logo} />
                    </Link>
                  </Grid>
                  <Grid item xs={7} container justifyContent="flex-end" alignItems="center">
                    <div>
                      <img
                        src={`${EVENT_IMG}/ic/icon_facebook.png`}
                        style={{ cursor: 'pointer', height: 40, paddingRight: 8 }}
                        onClick={() => {
                          window.open('https://www.facebook.com/KSPRS1966/');
                        }}
                        alt=""
                      />

                      <img
                        src={`${EVENT_IMG}/ic/icon_instagram.png`}
                        style={{ cursor: 'pointer', height: 40, paddingRight: 8 }}
                        onClick={() => {
                          window.open('https://www.instagram.com/prskorea/ ');
                        }}
                        alt=""
                      />

                      <img
                        src={`${EVENT_IMG}/ic/icon_youtube.png`}
                        style={{ cursor: 'pointer', height: 40, paddingRight: 8 }}
                        onClick={() => {
                          window.open('https://www.youtube.com/channel/UCcFvUVXjr0P4GS-gSC2SWtQ');
                        }}
                        alt=""
                      />
                    </div>
                    <div className={classes.topbarMenusDiv} id="sns_div">
                      <ul className={classes.menus} style={{ padding: 0 }}>
                        <li onClick={() => history.push('/')}>HOME</li>
                        {sessionStorage.getItem('_in_user_') ? (
                          <>
                            <li onClick={this.logout}>|&nbsp;&nbsp;LOGOUT</li>
                            <li onClick={() => history.push('/mypage')}>|&nbsp;&nbsp;MY PAGE</li>
                          </>
                        ) : (
                          <>
                            <li onClick={() => history.push('/signin')}>|&nbsp;&nbsp;LOGIN</li>
                            <li onClick={() => history.push('/choose')}>|&nbsp;&nbsp;SIGN UP</li>
                          </>
                        )}
                        {this.state.role === 'SCRL_MGR' ? <li onClick={() => history.push('/admin')}>|&nbsp;&nbsp;ADMIN</li> : null}
                      </ul>
                    </div>
                  </Grid>
                </Grid>
                {/*<Grid item>*/}
                {/*  <div*/}
                {/*    style={window.matchMedia('(max-width:600px)').matches ? { display: 'none' } : { fontSize: '0.9em', fontWeight: 'bold' }}*/}
                {/*  >*/}
                {/*    <ul className={classes.menus}>*/}
                {/*      <li>HOME</li>*/}
                {/*      <li>|&nbsp;&nbsp;LOGOUT</li>*/}
                {/*      <li>|&nbsp;&nbsp;MY PAGE</li>*/}
                {/*    </ul>*/}
                {/*  </div>*/}
                {/*</Grid>*/}
                {/* <div>
                  <img
                    src={`${EVENT_IMG}/ic/icon_facebook.png`}
                    style={{ cursor: 'pointer', height: 40, paddingRight: 8 }}
                    onClick={() => {
                      window.open('https://www.facebook.com/KSPRS1966/');
                    }}
                    alt=""
                  />

                  <img
                    src={`${EVENT_IMG}/ic/icon_instagram.png`}
                    style={{ cursor: 'pointer', height: 40, paddingRight: 8 }}
                    onClick={() => {
                      window.open('https://www.instagram.com/prskorea/ ');
                    }}
                    alt=""
                  />

                  <img
                    src={`${EVENT_IMG}/ic/icon_youtube.png`}
                    style={{ cursor: 'pointer', height: 40, paddingRight: 8 }}
                    onClick={() => {
                      window.open('https://www.youtube.com/channel/UCcFvUVXjr0P4GS-gSC2SWtQ');
                    }}
                    alt=""
                  />
                </div>
                <div className={classes.topbarMenusDiv} id="sns_div">
                  <ul className={classes.menus}>
                    <li onClick={() => history.push('/')}>HOME</li>
                    {sessionStorage.getItem('_in_user_') ? (
                      <>
                        <li onClick={this.logout}>|&nbsp;&nbsp;LOGOUT</li>
                        <li onClick={() => history.push('/mypage')}>|&nbsp;&nbsp;MY PAGE</li>
                      </>
                    ) : (
                      <>
                        <li onClick={() => history.push('/signin')}>|&nbsp;&nbsp;LOGIN</li>
                        <li onClick={() => history.push('/choose')}>|&nbsp;&nbsp;SIGN UP</li>
                      </>
                    )}
                    {this.state.role === 'SCRL_MGR' ? <li onClick={() => history.push('/admin')}>|&nbsp;&nbsp;ADMIN</li> : null}
                  </ul>
                </div> */}
              </Grid>
              {/* <div className={classes.topbarMenusDiv} id="sns_div">
                <ul className={classes.menus}>
                  <li onClick={() => history.push('/')}>HOME</li>
                  {sessionStorage.getItem('_in_user_') ? (
                    <>
                      <li onClick={this.logout}>|&nbsp;&nbsp;LOGOUT</li>
                      <li onClick={() => history.push('/mypage')}>|&nbsp;&nbsp;MY PAGE</li>
                    </>
                  ) : (
                    <>
                      <li onClick={() => history.push('/signin')}>|&nbsp;&nbsp;LOGIN</li>
                      <li onClick={() => history.push('/choose')}>|&nbsp;&nbsp;SIGN UP</li>
                    </>
                  )}
                  {this.state.role === 'SCRL_MGR' ? <li onClick={() => history.push('/admin')}>|&nbsp;&nbsp;ADMIN</li> : null}
                </ul>
              </div> */}
              {/*<Grid*/}
              {/*  container*/}
              {/*  xs={3}*/}
              {/*  style={window.matchMedia('(max-width:960px)').matches ? { display: 'flex', justifyContent: 'flex-end' } : { display: 'flex' }}*/}
              {/*>*/}
              {/*  /!* 모바일 메뉴버튼 위치 변경               *!/*/}
              {/*  <div className={classes.iconContainer}>*/}
              {/*    <IconButton onClick={this.mobileMenuOpen} className={classes.iconButton} color="inherit" aria-label="Menu">*/}
              {/*      <MenuIcon />*/}
              {/*    </IconButton>*/}
              {/*  </div>*/}
              {/*</Grid>*/}
            </Toolbar>
            <Grid container spacing={4} justifyContent="center">
              <Grid item xs={12}>
                {!this.props.noTabs && (
                  <React.Fragment>
                    <div className={classes.tabContainer}>
                      <SwipeableDrawer
                        anchor="right"
                        open={this.state.menuDrawer}
                        onClose={this.mobileMenuClose}
                        onOpen={this.mobileMenuOpen}
                        style={{ width: '60%' }}
                      >
                        <AppBar title="Menu" />
                        <List>
                          {Menu.map((item, index) => (
                            <ListItem
                              component={item.external ? MaterialLink : Link}
                              href={item.external ? item.pathname : null}
                              to={
                                item.external
                                  ? null
                                  : {
                                      pathname: item.pathname,
                                      search: this.props.location.search,
                                    }
                              }
                              button
                              key={item.label}
                            >
                              <ListItemText primary={item.label} />
                            </ListItem>
                          ))}
                        </List>
                      </SwipeableDrawer>
                      <div className="tabContainer">
                        <Tabs
                          value={this.current() || this.state.value}
                          indicatorColor="primary"
                          onChange={this.handleChange}
                          centered
                          className={classes.tabs}
                          onMouseOver={this.showMenus}
                          onMouseLeave={this.hideMenus}
                        >
                          {Menu.map((item, index) => {
                            if (item.display) {
                              return (
                                <Tab
                                  key={index}
                                  component={item.external ? MaterialLink : Link}
                                  href={item.external ? item.pathname : null}
                                  to={
                                    item.external
                                      ? null
                                      : {
                                          pathname: item.pathname,
                                          search: this.props.location.search,
                                        }
                                  }
                                  classes={{ root: classes.tabItem }}
                                  label={item.label}
                                />
                              );
                            }
                          })}
                        </Tabs>

                        <div className={'drawer'}>
                          <Grid container justifyContent={'center'} spacing={0} className={this.props.classes.drawerMenus}>
                            {Menu.map((item, index) => {
                              if (item.display) {
                                return (
                                  <ul key={item.label}>
                                    {item.children.map((menu, m_idx) => {
                                      if (menu.display) {
                                        return (
                                          <li
                                            onClick={() => {
                                              if (menu.open == false) {
                                                swal('', 'To be updated', 'info');
                                              } else {
                                                if (menu.url == false) {
                                                  this.props.history.push(menu.pathname);
                                                } else {
                                                  window.open('https://2021.prskorea.org//');
                                                }
                                              }
                                            }}
                                            key={`drawer-menu-${menu.label}`}
                                            style={{
                                              color: menu.open == false ? '#AEAEAE' : '#000000',
                                              fontWeight: menu.open == false ? 300 : 700,
                                            }}
                                          >
                                            {menu.label}
                                          </li>
                                        );
                                      }
                                    })}
                                  </ul>
                                );
                              }
                            })}
                          </Grid>
                        </div>
                      </div>
                    </div>
                  </React.Fragment>
                )}
              </Grid>
            </Grid>
          </AppBar>
          <Grid style={{ position: 'relative' }}>
            {this.props.location.pathname === '/main' || this.props.location.pathname === '/' ? (
              // todo:sgwoo 메인 이미지 가로 사이즈 수정
              <>
                <div
                  style={{
                    display: 'flex',
                    width: '100%',
                    // height: '30vw',
                    // backgroundImage: `url('/images/PRS2021/banner_bg.png')`,
                    // backgroundSize: '100% 100%',
                    justifyContent: 'center',
                    // alignItems: 'center',
                    backgroundColor: '#f5f5f5',
                  }}
                >
                  <img src={`${EVENT_IMG}/main_banner.png`} alt="PRS2022" style={{ width: '75%' }} />
                  {/* <img src="/images/PRS2021/main_banner_content@2x.png" alt="PRS2021" style={{ height: '70%' }} /> */}
                  {/* <img src="/images/PRS2021/prs_logo@2x.png" alt="PRS2021" style={{ height: '55%', marginRight: '70px' }} />
                  <img src="/images/PRS2021/banner_content@2x.png" alt="PRS2021" style={{ height: '35%' }} /> */}
                </div>
              </>
            ) : (
              <>
                <div
                  style={
                    {
                      // display: 'flex',
                      // width: '100%',
                      // height: '280px',
                      // backgroundImage: `url('/images/PRS2021/banner_bg.png')`,
                      // backgroundSize: '100% 100%',
                      // justifyContent: 'center',
                      // alignItems: 'center',
                    }
                  }
                >
                  <img src={`${EVENT_IMG}/sub_banner.png`} alt="" style={{ width: '100%' }} />
                  {/* <img src="/images/PRS2021/prs_logo@2x.png" alt="PRS2021" style={{ height: '55%', marginRight: '70px' }} />
                  <img src="/images/PRS2021/banner_content@2x.png" alt="PRS2021" style={{ height: '35%' }} /> */}
                </div>
              </>
            )}
          </Grid>
          <Grid container justifyContent={'center'} alignItems={'center'} style={{ border: '1px solid #f5f5f5' }}>
            <Grid
              container
              justifyContent="flex-start"
              alignItems={'center'}
              className={classes.breadcrumbs}
              item
              xs={8}
              style={this.props.location.pathname === '/main' || this.props.location.pathname === '/' ? { display: 'none' } : {}}
            >
              <Grid item className={classes.crumbs}>
                <HomeIcon />
              </Grid>
              <Grid item className={classes.crumbs}>
                {Menu[this.props.MIdx].label}
              </Grid>
              <Grid item className={classes.crumbs}>
                <Grid container justifyContent={'space-between'} alignItems={'center'} ref={this.myRef} onClick={this.handleToggle}>
                  <Grid item>{Menu[this.props.MIdx].children[this.props.SIdx].label}</Grid>
                  <Grid item style={{ marginTop: '5px' }}>
                    <ArrowDropDownIcon />
                  </Grid>
                </Grid>
                <Popper open={this.state.submenuOpen} anchorEl={this.myRef.current} role={undefined} transition disablePortal>
                  {({ TransitionProps, placement }) => (
                    <Grow
                      {...TransitionProps}
                      style={{
                        transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom',
                      }}
                    >
                      <Paper>
                        <ClickAwayListener onClickAway={this.handleClose}>
                          <MenuList id="split-button-menu">
                            {Menu[this.props.MIdx].children.map((menu) => {
                              if (menu.display) {
                                return (
                                  <MenuItem
                                    key={`crumb-menu-${menu.label}`}
                                    onClick={() => {
                                      if (menu.open === false) {
                                        swal('', 'To be updated', 'info');
                                      } else {
                                        if (menu.url == false) {
                                          history.push(menu.pathname);
                                        } else {
                                          window.open('https://2021.prskorea.org//');
                                        }
                                      }
                                    }}
                                  >
                                    {menu.label}
                                  </MenuItem>
                                );
                              }
                            })}
                          </MenuList>
                        </ClickAwayListener>
                      </Paper>
                    </Grow>
                  )}
                </Popper>
              </Grid>
            </Grid>
          </Grid>
        </div>

        {/* 0609 수정 요청사항 반영 시간/ SNS 제거 */}
        {/* <div className={classes.timeZoneDiv}>
          <div style={{ textAlign: 'center' }}>
            <div style={{ paddingBottom: 16 }}>
              <Typography style={{ fontSize: '1.4em', color: '#237a9d', fontWeight: 'bold', paddingTop: '16px' }}>
                Visit Social Network
              </Typography>
            </div>
            <div>
              <div style={{ paddingBottom: 16 }}>
                <img
                  src={`${EVENT_IMG}/ic/ic_facebook_2.png`}
                  style={{ cursor: 'pointer' }}
                  onClick={() => {
                    window.open('https://www.facebook.com/KSPRS1966/');
                  }}
                />
              </div>
              <div style={{ paddingBottom: 16 }}>
                <img
                  src={`${EVENT_IMG}/ic/ic_insta_2.png`}
                  style={{ cursor: 'pointer' }}
                  onClick={() => {
                    window.open('https://www.instagram.com/prskorea/ ');
                  }}
                />
              </div>
              <div style={{ paddingBottom: 16 }}>
                <img
                  src={`${EVENT_IMG}/ic/ic_youtube_2.png`}
                  style={{ cursor: 'pointer' }}
                  onClick={() => {
                    window.open('https://www.youtube.com/channel/UCcFvUVXjr0P4GS-gSC2SWtQ');
                  }}
                />
              </div>
            </div>
          </div>

          <div className={`${classes.timezoneBox} ${classes.yourTimezoneDiv}`}>
            <div>
              <Typography className={classes.timezoneName}>EST</Typography>
            </div>
            <div className={classes.timezoneTime}>
              <Typography className={classes.timezoneDate}>{now.tz('EST').format('YYYY.MM.DD')}</Typography>
              <Typography>
                {now.tz('EST').format('hh:mm')} <span>{now.tz('EST').format('A')}</span>
              </Typography>
            </div>
          </div>
          <div className={`${classes.timezoneBox} ${classes.gmtDiv}`}>
            <div>
              <Typography className={classes.timezoneName}>GMT</Typography>
            </div>
            <div className={classes.timezoneTime}>
              <Typography className={classes.timezoneDate}>{now.tz('GMT').format('YYYY.MM.DD')}</Typography>
              <Typography>
                {now.tz('GMT').format('hh:mm')} <span>{now.tz('GMT').format('A')}</span>
              </Typography>
            </div>
          </div>
          <div className={`${classes.timezoneBox} ${classes.kstDiv}`}>
            <div>
              <Typography className={classes.timezoneName}>Korea Standard Time</Typography>
            </div>
            <div className={classes.timezoneTime}>
              <Typography className={classes.timezoneDate}>{now.tz('Asia/Seoul').format('YYYY.MM.DD')}</Typography>
              <Typography>
                {now.tz('Asia/Seoul').format('hh:mm')} <span>{now.tz('Asia/Seoul').format('A')}</span>
              </Typography>
            </div>
          </div>
        </div> */}
      </>
    );
  }
}

export default withRouter(withStyles(styles, { withTheme: true })(Topbar));
